<template>
  <section class="pt-7 px-10 roboto homecontainer mx-auto">
    <BtnFiltrar class="mb-33 block md:hidden" />
    <div v-if="haveCourses">
      <h2
        class="text-left font-black text-l mb-7 text-skin-secondary"
        v-text="'Mis cursos'"
      />

      <div
        class="grid items-center md:grid-cols-miscursos_desktop lg:grid-cols-3fr 1xl:grid-cols-miscursos_desktop md:gap-36"
      >
        <CourseCard
          :responsive="true"
          v-for="(course, index) in GET_USERCOURSES.data"
          :key="index"
          :course="course"
          :name="course.name"
          :progress="course.progress"
          :owner_name="course.propietary_name"
          :owner_lname="course.propietary_lastname"
          :parse_data="course.mounted_course_data"
          :parse="true"
          :image="course.image"
          :source_id="course.mounted_course_id"
          class="justify-self-center mb-30"
        />
      </div>

      <Pagination
        :last_page="GET_USERCOURSES.last_page"
        :current_page="currentPage"
        @prev="prevpage"
        @next="nextpage"
        class="block mb-93"
      />
    </div>

    <section
      class="grid 1fr items-center justify-center justify-items-center"
      v-else
    >
      <img
        src="../assets/emptystate.png"
        width="200"
        height="200"
      />
      <h2
        class="text-skin-primary font-semibold text-l my-20"
        v-text="'No estas registrado en ningun curso aun.'"
      />
    </section>

    <CourseInteresed />
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import Pagination from "../components/Pagination.vue";
import CourseCard from "../components/CourseCard.vue";
import BtnFiltrar from "../components/BtnFiltrar.vue";
import CourseInteresed from "../components/CourseInteresed.vue";

export default {
  components: {
    Pagination,
    CourseCard,
    BtnFiltrar,
    CourseInteresed,
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  computed: {
    ...mapGetters("userCourses", ["GET_USERCOURSES"]),
    haveCourses() {
      if (this.GET_USERCOURSES.data)
        if (this.GET_USERCOURSES.data.length > 0) return true;

      return false;
    },
  },
  mounted() {
    this.$store.dispatch("userCourses/get_userCourses", {
      perPage: 4,
      currentPage: this.currentPage,
    });

    let x = window.matchMedia("(max-width: 450px)");
    if (x.matches) {
      this.$store.dispatch("userCourses/get_userCourses", {
        perPage: 1,
        currentPage: this.currentPage,
      });
    }
  },
  methods: {
    nextpage() {
      if (this.currentPage < this.GET_USERCOURSES.last_page) {
        let nextpage = this.currentPage + 1;
        let x = window.matchMedia("(max-width: 450px)");
        this.currentPage = this.currentPage + 1;

        this.$store.dispatch("userCourses/get_userCourses", {
          perPage: 4,
          currentPage: nextpage,
        });

        if (x.matches) {
          this.$store.dispatch("userCourses/get_userCourses", {
            perPage: 1,
            currentPage: nextpage,
          });
        }
      }
    },
    prevpage() {
      if (this.currentPage > 1) {
        this.currentPage = this.currentPage - 1;
        let prevpage = this.currentPage - 1;
        let x = window.matchMedia("(max-width: 450px)");

        this.$store.dispatch("userCourses/get_userCourses", {
          perPage: 4,
          currentPage: prevpage,
        });

        if (x.matches) {
          this.$store.dispatch("userCourses/get_userCourses", {
            perPage: 1,
            currentPage: prevpage,
          });
        }
      }
    },
  },
};
</script>
<style scoped>
.emptystate {
  width: 200px;
  height: 200px;
  background-image: url("");
  background-size: contain;
  background-position: center;
}
</style>
